module.exports = __webpack_public_path__ + "media/images/reward-card-coin-9da3b4fd03ab271eaf89270f2cbc5a57.svg";